import { ThemeProvider, createTheme } from '@mui/material/styles'
import { CssBaseline } from '@mui/material'
import { plannerTheme } from 'Common/Supplyvue-ui/Theme/planner-theme'

export const AppThemeProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const theme = createTheme(plannerTheme)

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}
